// src/pages/GroceryPage.jsx
import React from "react";
import groceryImg from "../assets/grocerybanner.jpg"; // correct relative path
import './Grocery.css'; // make sure the file exists with exact name

export default function GroceryPage() {
  return (
    <div className="grocery-container">

      {/* Top Image */}
      <div className="grocery-top-image">
        <img src={groceryImg} alt="Grocery Section" />
      </div>

      {/* Page Title */}
      <h1>Grocery</h1>

      {/* Description */}
      <p>
        Our grocery section is stocked with a wide range of high-quality products to meet your everyday needs.
        From essential staples like rice, pulses, and spices to premium packaged foods and condiments, we ensure
        freshness and authenticity in every product. Whether you’re looking for organic options, international flavors,
        or local specialties, our shelves are filled with the best selections to keep your kitchen well-stocked.
        We understand the importance of convenience in your busy life, which is why we offer a mix of traditional
        and modern grocery items. Whether it’s ready-to-cook meals, healthy snacks, or premium dry fruits, our
        selection is curated to cater to all your needs. Our commitment to quality ensures that every product
        undergoes strict checks, providing you with only the best.
      </p>

    </div>
  );
}